<script setup lang="ts">
import type { Breadcrumbs } from '@@/shared/application';

withDefaults(
  defineProps<{
    items: Breadcrumbs
    textTag?: 'h1' | 'span'
  }>(),
  {
    textTag: 'span',
  },
);
</script>

<template>
  <nav>
    <IadBreadcrumbsItem
      :item="{
        text: $t(`core.common.real_estate`),
        to: { name: `index` },
        id: `home`,
      }"
      :text-tag
    />
    <IadBreadcrumbsItem
      v-for="item of items"
      :key="item.id"
      :item
      :text-tag
    />
  </nav>
</template>
